import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
// 视图组件
var view = {
  tabs: function tabs() {
    return import('@/layouts/tabs');
  },
  blank: function blank() {
    return import('@/layouts/BlankView');
  },
  page: function page() {
    return import('@/layouts/PageView');
  }
};

// 路由组件注册
var routerMap = {
  login: {
    path: 'login',
    name: '登录',
    authority: '*',
    component: function component() {
      return import('@/pages/login');
    }
  },
  root: {
    path: '/',
    name: '首页',
    redirect: '/login',
    component: view.tabs
  },
  success: {
    name: '成功',
    component: function component() {
      return import('@/pages/result/Success');
    }
  },
  error: {
    name: '失败',
    component: function component() {
      return import('@/pages/result/Error');
    }
  },
  exception: {
    name: '异常页',
    icon: 'warning',
    component: view.blank
  },
  exp403: {
    authority: '*',
    name: 'exp403',
    path: '403',
    component: function component() {
      return import('@/pages/exception/403');
    }
  },
  exp404: {
    name: 'exp404',
    path: '404',
    component: function component() {
      return import('@/pages/exception/404');
    }
  },
  exp500: {
    name: 'exp500',
    path: '500',
    component: function component() {
      return import('@/pages/exception/500');
    }
  }
};
export default routerMap;